import { render, staticRenderFns } from "./WorkshopGroupList.vue?vue&type=template&id=7430e1f6&scoped=true&"
import script from "./WorkshopGroupList.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopGroupList.vue?vue&type=style&index=0&id=7430e1f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7430e1f6",
  null
  
)

export default component.exports